import React from 'react'
import PropTypes from 'prop-types'

const MinusCircleIcon = ({
  size = '24',
  color = '#101820',
  strokeWidth = '2.5',
  fillColor = 'none',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 26 26"
      fill={fillColor}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.6344 12.8792H8.70044"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M13.1674 23.862C19.335 23.862 24.3349 18.9449 24.3349 12.8792C24.3349 6.81363 19.335 1.89648 13.1674 1.89648C6.99983 1.89648 2 6.81363 2 12.8792C2 18.9449 6.99983 23.862 13.1674 23.862Z"
        stroke={color}
        strokeWidth={strokeWidth}
      />
    </svg>
  )
}

export default React.memo(MinusCircleIcon)

MinusCircleIcon.propTypes = {
  size: PropTypes.string,
  color: PropTypes.string,
  fillColor: PropTypes.string,
  strokeWidth: PropTypes.string,
}
